import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9l4 4h-8l4 -4","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconCircleCaretUp = createReactComponent('outline', 'circle-caret-up', 'CircleCaretUp', __iconNode);

export default IconCircleCaretUp;